import { createSlice } from "@reduxjs/toolkit";
import _ from "lodash";
import { RootState, RootThunk } from "../../../../app/store";
import { api } from "../../../../app/applicationSlice";
import * as service from "../../../../services/formula";
import { NoFormulaParmas } from "../../../../services/formula";
import { NoFormulasDetail } from "../../../../models/ModalList";


interface NoFormulaState {
  FormulaData: [],
  Total: 0,

  Current: 1,
  departments: NoFormulasDetail[];
}
const initialState: NoFormulaState = {
  FormulaData: [],
  Total: 0,

  Current: 1,
  departments: [],
 
};
const noformulaSlice = createSlice({
  name: "formula",
  initialState,
  reducers: {
    setData(state, action) {
      state.FormulaData = action.payload
    },
    setTotal(state, action) {
      state.Total = action.payload
    },
    setCurrent(state, action) {
      state.Current = action.payload
    },
    setFormulaDetail: (state, action) => {
      state.departments = action.payload;
    },
  
  },
});

export const {
  setData, 
  setTotal,
  setCurrent,
  setFormulaDetail,
} = noformulaSlice.actions;

export function getformulaList(params: NoFormulaParmas): RootThunk {
  return api(service.getNoformulaList(params), (data: any, dispatch) => {
    dispatch(setData(data.records))
        dispatch(setTotal(data.total))
  });
}

export function getformula(params: NoFormulaParmas): RootThunk {
  return api(service.getNoformula(params), (data: any, dispatch) => {
    dispatch(setFormulaDetail([data]));
  });
}


export const selectFormulaData = (state: RootState) => state.formula.FormulaData

export const selectTotal = (state: RootState) => state.formula.Total

export const selectCurrent = (state: RootState) => state.formula.Current

export const selectFarmulaDetail = (state: RootState) =>
  state.FormulasDetail.departments;



export default noformulaSlice.reducer;
